import { Container, Flex, Text, chakra, Button, Box, Image, Stack } from "@chakra-ui/react";
import React from "react";
import { withTranslation } from "react-i18next";
import { FaPlay, FaDownload, FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";

const Header = ({ t }) => {
  return (
    <Box
      id="home"
      position="relative"
      minH="80vh"
      maxH="90vh"
      bgGradient="linear(to-br, #FFD700 0%, #FF8C00 50%, #FF6B35 100%)"
      overflow="hidden"
      mb={8}
    >
      {/* Background decorative elements */}
      <Box
        position="absolute"
        top="-50px"
        right="-50px"
        w="200px"
        h="200px"
        bg="whiteAlpha.300"
        borderRadius="full"
        filter="blur(40px)"
      />
      <Box
        position="absolute"
        bottom="-100px"
        left="-100px"
        w="300px"
        h="300px"
        bg="whiteAlpha.200"
        borderRadius="full"
        filter="blur(60px)"
      />
      <Box
        position="absolute"
        top="20%"
        left="10%"
        w="150px"
        h="150px"
        bg="whiteAlpha.100"
        borderRadius="full"
        filter="blur(30px)"
      />

      <Container maxW={"container.xl"} position="relative" zIndex={2}>
        <Flex
          alignItems={"center"}
          justifyContent="center"
          flexDir="column"
          color="white"
          py={20}
          textAlign="center"
        >
          <Text
            fontSize={{ base: "36px", md: "60px", lg: "72px" }}
            fontWeight="900"
            mb="1.5rem"
            lineHeight="1.1"
            textShadow="0 4px 8px rgba(0,0,0,0.3)"
            fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
            letterSpacing="-0.02em"
          >
            <chakra.span
              color="white"
              textShadow="0 4px 12px rgba(0,0,0,0.4)"
              display="block"
              mb={2}
            >
              واجهتك الأولى
            </chakra.span>
            <chakra.span
              color="yellow.200"
              textShadow="0 4px 12px rgba(0,0,0,0.5)"
              display="block"
              fontSize={{ base: "40px", md: "64px", lg: "76px" }}
              fontWeight="900"
            >
              للنجاح
            </chakra.span>
          </Text>

          <Text
            fontSize={{ base: "20px", md: "24px", lg: "28px" }}
            mb="2rem"
            maxW="700px"
            opacity="0.95"
            lineHeight="1.7"
            fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
            fontWeight="500"
            textShadow="0 2px 4px rgba(0,0,0,0.2)"
            color="whiteAlpha.900"

          >
            منصة تعليمية متطورة تهدف إلى تطوير العملية التعليمية ومساعدة الطلاب في تحقيق النجاح والتفوق في جميع المواد الدراسية من خلال خدمات تعليمية متميزة ومحتوى تفاعلي متقدم
          </Text>

          <Stack
            direction={{ base: "column", md: "row" }}
            spacing={4}
            align="center"
            justify="center"
            w="full"
            maxW="500px"
          >
            <Link to="/login">
              <Button
                size="lg"
                bg="white"
                color="orange.600"
                _hover={{
                  bg: "orange.50",
                  transform: "translateY(-3px) scale(1.02)",
                  boxShadow: "0 12px 30px rgba(0,0,0,0.25)"
                }}
                _active={{ transform: "translateY(-1px) scale(0.98)" }}
                transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                rightIcon={<FaArrowRight />}
                px={10}
                py={7}
                fontSize="20px"
                fontWeight="800"
                borderRadius="full"
                boxShadow="0 6px 20px rgba(0,0,0,0.25)"
                fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                letterSpacing="0.5px"
                textTransform="uppercase"
              >
                تسجيل الدخول
              </Button>
            </Link>
            <Link to="/signup">
              <Button
                size="lg"
                variant="outline"
                borderColor="white"
                borderWidth="3px"
                color="white"
                _hover={{
                  bg: "whiteAlpha.200",
                  transform: "translateY(-3px) scale(1.02)",
                  boxShadow: "0 12px 30px rgba(0,0,0,0.25)",
                  borderColor: "yellow.200"
                }}
                _active={{ transform: "translateY(-1px) scale(0.98)" }}
                transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                leftIcon={<FaPlay />}
                px={10}
                py={7}
                fontSize="20px"
                fontWeight="800"
                borderRadius="full"
                fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                letterSpacing="0.5px"
                textTransform="uppercase"
              >
                سجل الآن
              </Button>
            </Link>
          </Stack>
        </Flex>
      </Container>
    </Box>
  );
};

export default withTranslation()(Header);
